import type { Workout } from '@shared/types';
import { useState } from 'react';

/**
 * Hook for managing workout swap functionality
 */
export const useWorkoutSwap = () => {
  const [isSwapMode, setIsSwapMode] = useState(false);
  const [selectedWorkout, setSelectedWorkout] = useState<Workout | null>(null);
  const [isSwapping, setIsSwapping] = useState(false);
  const [swapConfirmOpen, setSwapConfirmOpen] = useState(false);
  const [workoutToSwap, setWorkoutToSwap] = useState<Workout | null>(null);

  const startSwapMode = () => {
    setIsSwapMode(true);
    setSelectedWorkout(null);
  };

  const cancelSwapMode = () => {
    setIsSwapMode(false);
    setSelectedWorkout(null);
    setWorkoutToSwap(null);
    setSwapConfirmOpen(false);
  };

  const selectWorkoutForSwap = (workout: Workout) => {
    if (!selectedWorkout) {
      setSelectedWorkout(workout);
    } else if (selectedWorkout.index !== workout.index) {
      setWorkoutToSwap(workout);
      setSwapConfirmOpen(true);
    }
  };

  return {
    isSwapMode,
    selectedWorkout,
    isSwapping,
    swapConfirmOpen,
    workoutToSwap,
    setIsSwapping,
    setSwapConfirmOpen,
    startSwapMode,
    cancelSwapMode,
    selectWorkoutForSwap,
  };
};
